export default __webpack_public_path__ + "static/media/ka-logo-black.e598ee3d.png";